import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/comics";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const preview = faqs.slice(0, 4);

  return (
    <section className="bg-background-100 border-y border-background-300/50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <div>
            <span className="text-xs font-semibold tracking-widest text-accent-500">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">追漫老铁常见问题</h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              关于榜单计算、分类推荐、投稿反馈等疑问，这里都有答案。想了解更完整的说明，
              可以进入常见问题页面查看全部内容。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors"
            >
              查看全部问题<i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex flex-col gap-3">
            {preview.map((f, i) => {
              const open = openIndex === i;
              return (
                <div key={i} className="rounded-lg bg-background-50 border border-background-300/50 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : i)}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    aria-expanded={open}
                  >
                    <span className="text-sm md:text-base font-semibold text-foreground-950">{f.q}</span>
                    <i className={`${open ? "ri-subtract-line text-primary-400" : "ri-add-line text-foreground-600"} shrink-0 text-lg transition-transform`}></i>
                  </button>
                  {open && (
                    <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}